/**
 *
 * Asynchronously loads the component for Addasset
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Addasset = lazyLoad(
  () => import('./index'),
  module => module.Addasset,
);
